import AssetBookInformation from './AssetBookInformation'
export default AssetBookInformation
